var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.002 2.75732H5.00201C3.89901 2.75732 3.00201 3.65432 3.00201 4.75732V8.75732H5.00201V4.75732H19.002V18.7573H5.00201V14.7573H3.00201V18.7573C3.00201 19.8603 3.89901 20.7573 5.00201 20.7573H19.002C20.105 20.7573 21.002 19.8603 21.002 18.7573V4.75732C21.002 3.65432 20.104 2.75732 19.002 2.75732Z",
    fill: "#292829"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.7573L16 11.7573L11 7.75732V10.7583H3V12.7583H11V15.7573Z",
    fill: "#292829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon-logout.0303f5ee88dce425d13eaa3b968f0e68.svg";
export { ForwardRef as ReactComponent };